import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "px-8 pt-3" }
const _hoisted_2 = { class: "flex flex-wrap" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "flex space-x-3 items-center justify-star text-black border-b-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "inline-block align-middle" }
const _hoisted_7 = {
  class: "w-8 h-8 fill-current",
  viewbox: "0 0 30 30"
}
const _hoisted_8 = ["d"]
const _hoisted_9 = { class: "inline-block align-middle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskPage = _resolveComponent("TaskPage")!
  const _component_TimeLinePage = _resolveComponent("TimeLinePage")!
  const _component_RecordPage = _resolveComponent("RecordPage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("header", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["p-3 text-lg font-bold cursor-pointer", 
                _ctx.selectedTab === tab.name
                  ? 'text-warningColor border-b-4 border-warningColor'
                  : 'text-gray-400 hover:text-warningColor '
              ]),
                  key: tab.name,
                  onClick: ($event: any) => (_ctx.selectedTab = tab.name)
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_7, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: tab.icon
                      }, null, 8, _hoisted_8)
                    ]))
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(tab.display), 1)
                ], 10, _hoisted_5))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      (_ctx.selectedTab === 'task')
        ? (_openBlock(), _createBlock(_component_TaskPage, {
            key: 0,
            groupHeaders: _ctx.statusHeaders,
            eventData: _ctx.eventHeaders
          }, null, 8, ["groupHeaders", "eventData"]))
        : _createCommentVNode("", true),
      (_ctx.selectedTab === 'timeline')
        ? (_openBlock(), _createBlock(_component_TimeLinePage, {
            key: 1,
            caption: "Activity",
            eventStatusHeaders: _ctx.statusHeaders,
            eventHeaders: _ctx.eventHeaders,
            eventData: _ctx.data,
            baseDate: _ctx.startDate,
            "onUpdate:baseDate": _cache[0] || (_cache[0] = ($event: any) => (_ctx.startDate = $event))
          }, null, 8, ["eventStatusHeaders", "eventHeaders", "eventData", "baseDate"]))
        : _createCommentVNode("", true),
      (_ctx.selectedTab === 'record')
        ? (_openBlock(), _createBlock(_component_RecordPage, {
            key: 2,
            groupHeaders: _ctx.statusHeaders,
            eventData: _ctx.eventHeaders
          }, null, 8, ["groupHeaders", "eventData"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}